export default __webpack_public_path__ + "static/media/GSRR_0.f4f13130.svg";